import { render } from "./ApprovalRemarksDialog.vue?vue&type=template&id=c585e848"
import script from "./ApprovalRemarksDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalRemarksDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__